export default "__VITE_ASSET__Dg0n25k1__"